import axios from 'axios'
import xml2js from 'xml2js'
import store from '@/store'

const parser = new xml2js.Parser()
const client = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
})
client.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    if(error.response && error.response.data) {
      parser.parseString(error.response.data, (err, result) => {
        store.dispatch('loader/CHANGE_DETAIL', `${ result.errors.error[0].$.field } ${ result.errors.error[0]._ }`)
      })
    }
    return Promise.reject(error)
  }
)
export default client
